import { jsx as _jsx } from "react/jsx-runtime";
import { JordanForm, SaudiArabiaForm, UnitedArabEmiratesForm } from "../AddressForms";
import { AsianAddressForm } from "../AsianAddressForm";
import { SingleFieldLookupAddressForm } from "../SingleFieldLookupAddressForm";
import { StandardAddressForm } from "../StandardAddressForm";
export const AddressFormProvider = ({ fieldName, postCodeConfig, locationServiceAutocompleteProvider = "google", formType = "standard", orderDeliveryLimits, }) => {
    if (formType === "single_field_lookup") {
        return (_jsx(SingleFieldLookupAddressForm, { fieldName: fieldName, autocompleteProvider: locationServiceAutocompleteProvider }));
    }
    if (formType === "saudi_arabia") {
        return (_jsx(SaudiArabiaForm, { fieldName: fieldName, locationServiceAutocompleteProvider: locationServiceAutocompleteProvider }));
    }
    if (formType === "united_arab_emirates") {
        return _jsx(UnitedArabEmiratesForm, { fieldName: fieldName });
    }
    if (formType === "jordan") {
        return (_jsx(JordanForm, { fieldName: fieldName, locationServiceAutocompleteProvider: locationServiceAutocompleteProvider }));
    }
    if (formType === "extended_asian" || formType === "extended_asian_reversed") {
        return (_jsx(AsianAddressForm, { fieldName: fieldName, postCodeConfig: postCodeConfig, enableStreetNameAutocomplete: true, orderDeliveryLimits: orderDeliveryLimits, locationServiceAutocompleteProvider: locationServiceAutocompleteProvider }));
    }
    return (_jsx(StandardAddressForm, { fieldName: fieldName, enableStreetNameAutocomplete: true, postCodeConfig: postCodeConfig, orderDeliveryLimits: orderDeliveryLimits, locationServiceAutocompleteProvider: locationServiceAutocompleteProvider }));
};
//# sourceMappingURL=AddressFormProvider.js.map